export function StatusBadge({ status, colorMap }) {
  const color = colorMap?.[status]?.color || "#64748B";
  const label = colorMap?.[status]?.label || status;
  return (
    <span
      className="px-2 py-1 text-xs uppercase tracking-wide font-bold"
      style={{ color }}
      data-testid={`status-badge-${status}`}
    >
      {label}
    </span>
  );
}
